import { SvgIcon, SvgIconProps } from '@mui/material'

const ArrowRightSmallUpIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.03 6.97a.75.75 0 0 1 0 1.06l-8.5 8.5a.75.75 0 0 1-1.06-1.06l8.5-8.5a.75.75 0 0 1 1.06 0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 7.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V8.25H7.5a.75.75 0 0 1-.75-.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ArrowRightSmallUpIcon
